import { render, staticRenderFns } from "./RegionChooser.vue?vue&type=template&id=1584bfc6&scoped=true&"
import script from "./RegionChooser.vue?vue&type=script&lang=js&"
export * from "./RegionChooser.vue?vue&type=script&lang=js&"
import style0 from "./RegionChooser.vue?vue&type=style&index=0&id=1584bfc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1584bfc6",
  null
  
)

export default component.exports